package com.devi3east.bashbuddy.features.app.navigation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.navigation.compose.NavHost
import com.devi3east.bashbuddy.account.organization.navigation.organizationNavGraph
import com.devi3east.bashbuddy.account.profile.navigation.profileNavGraph
import com.devi3east.bashbuddy.auth.domain.models.UserType
import com.devi3east.bashbuddy.auth.navigation.resetPasswordNavGraph
import com.devi3east.bashbuddy.auth.navigation.signInNavGraph
import com.devi3east.bashbuddy.auth.navigation.signUpNavGraph
import com.devi3east.bashbuddy.cart.navigation.cartNavGraph
import com.devi3east.bashbuddy.cart.navigation.stripeSuccessNavGraph
import com.devi3east.bashbuddy.dashboard.navigation.dashboardNavGraph
import com.devi3east.bashbuddy.favorites.navigation.favoriteEventsNavGraph
import com.devi3east.bashbuddy.features.app.data.AppState
import com.devi3east.bashbuddy.features.common.util.DeepLinkListener
import com.devi3east.bashbuddy.features.detail.navigation.detailNavGraph
import com.devi3east.bashbuddy.features.events.detail.navigation.eventDetailNavGraph
import com.devi3east.bashbuddy.features.events.detail.navigation.navigateToEventDetail
import com.devi3east.bashbuddy.features.events.feed.navigation.eventFeedNavGraph
import com.devi3east.bashbuddy.features.tabs.ui.TabsScreen
import com.devi3east.bashbuddy.footer.navigation.footerNavGraph
import com.devi3east.bashbuddy.leaderboard.navigation.leaderboardNavGraph
import com.devi3east.bashbuddy.prizeList.navigation.navigateToPrizeList
import com.devi3east.bashbuddy.prizeList.navigation.prizeListNavGraph
import com.devi3east.bashbuddy.search.navigation.searchNavGraph
import com.devi3east.bashbuddy.ticketDetail.navigation.navigateToTicketDetail
import com.devi3east.bashbuddy.ticketDetail.navigation.ticketDetailNavGraph

@Composable
fun AppNavHost(
    appState: AppState,
    startDestination: String
) {
    val authViewModel = appState.authViewModel
    val eventFeedViewModel = appState.eventFeedViewModel
    val authUiState by authViewModel.uiState.collectAsState()
    val authToken = authUiState.token
    val profile = authUiState.profile

    LaunchedEffect(authToken, profile?._id) {
        if (!authToken.isNullOrBlank() && profile != null) {
            appState.loadCurrentUserProfile()
        }
    }

    LaunchedEffect(authToken, profile?.userType) {
        if (!authToken.isNullOrBlank() && profile?.userType == UserType.ORGANIZATION) {
            appState.loadCurrentOrganization()
        }
    }

    val navController = appState.navController
    DeepLinkListener(navController)

    TabsScreen(
        appState = appState,
        navController = navController,
        eventFeedViewModel = eventFeedViewModel,
        authViewModel = authViewModel
    ) { innerModifier ->

        NavHost(
            navController = navController,
            startDestination = startDestination,
            modifier = innerModifier
        ) {

            eventFeedNavGraph(appState) { eventId, slug ->
                navController.navigateToEventDetail(eventId, slug)
            }

            searchNavGraph(appState) { eventId, slug ->
                navController.navigateToEventDetail(eventId, slug)
            }

            favoriteEventsNavGraph(appState) { eventId, slug ->
                navController.navigateToEventDetail(eventId, slug)
            }

            dashboardNavGraph(
                appState = appState,
                navigateToEventDetail = { eventId, slug ->
                    navController.navigateToEventDetail(eventId, slug)
                },
                navigateToTicketDetail = { ticketId ->
                    navController.navigateToTicketDetail(ticketId)
                },
                navigateToPrizeList = { eventId, slug ->
                    navController.navigateToPrizeList(eventId, slug)
                }
            )

            profileNavGraph(appState)

            organizationNavGraph(appState)

            eventDetailNavGraph(appState)
            ticketDetailNavGraph(appState)
            prizeListNavGraph(appState)

            cartNavGraph(appState)
            stripeSuccessNavGraph(appState)
            resetPasswordNavGraph(appState)

            signInNavGraph(appState)
            signUpNavGraph(appState)

            leaderboardNavGraph(appState)
            footerNavGraph(appState)

            detailNavGraph(
                onBackClick = {},
                isUserLoggedIn = { false },
                openLoginBottomSheet = {},
                openSignUpBottomSheet = {}
            )
        }
    }
}